<template>
  <div id="auth-card" class="p-fluid">
    <div id="auth-card-mobile-logo" class="w-full flex justify-content-center align-items-center md:hidden">
      <img alt="parsepay logo" src="../assets/images/logo-full-2x.png" height="85">
    </div>
    <slot></slot>
  </div>
</template>
